export const ColumnKey_LeftColumn = 'column-key_left-column';
export const ColumnKey_RightColumn = 'column-key_right-column';
export const ColumnKey_MiddleColumn = 'column-key_middle-column';
//Floating columns
export const ColumnKey_FloatingLeft = 'column-key_floating-left';
export const ColumnKey_FloatingMiddle = 'column-key_floating-middle';
export const ColumnKey_FloatingRight = 'column-key_floating-right';
export const FloatingColumns = [
    ColumnKey_FloatingLeft,
    ColumnKey_FloatingMiddle,
    ColumnKey_FloatingRight,
];
export const ColumnKeys = [
    ...FloatingColumns,
    ColumnKey_LeftColumn,
    ColumnKey_MiddleColumn,
    ColumnKey_RightColumn,
];
export const PanelKey_Home = 'panel-key__home';
export const PanelKey_Inbox = 'panel-key__inbox';
export const PanelKey_HPI = 'panel-key__hpi';
export const PanelKey_ProtocolInfo = 'panel-key__protocol-info';
export const PanelKey_ProvideInfo = 'panel-key__provide-info';
export const PanelKey_SmartDocs = 'panel-key__smart-docs';
export const PanelKey_Spotlight = 'panel-key__spotlight';
export const PanelKey_Findings = 'panel-key__findings';
export const PanelKey_NextSteps = 'panel-key__next-steps';
export const PanelKey_AddProtocolData = 'panel-key__add-protocol-data';
export const PanelKey_Settings = 'panel-key__settings';
export const PanelKey_PatientDataLoader = 'panel-key__patient-data-loader';
export const PanelKey_EventFeed = 'panel-key__event-feed';
export const PanelKeys = [
    PanelKey_Home,
    PanelKey_Inbox,
    PanelKey_HPI,
    PanelKey_ProtocolInfo,
    PanelKey_ProvideInfo,
    PanelKey_SmartDocs,
    PanelKey_Spotlight,
    PanelKey_Findings,
    PanelKey_NextSteps,
    PanelKey_AddProtocolData,
    PanelKey_Settings,
    PanelKey_PatientDataLoader,
    PanelKey_EventFeed,
];
//# sourceMappingURL=types.js.map